import { createElement } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';
import { CustomLink, SubTitle, styled } from '@teko/ds-desktop';
import { convertMegaMenu } from '../../helpers/megaMenu.es.js';
import { EnhancedImage } from '../EnhancedImage/EnhancedImage.es.js';

const MenuPanel = ({ menu, className, type, }) => {
    var _a, _b;
    const bannerWidth = '14.625rem';
    if (!menu || (!((_a = menu.banner) === null || _a === void 0 ? void 0 : _a.src) && !menu.children.length))
        return null;
    const bannerSrc = (_b = menu.banner) === null || _b === void 0 ? void 0 : _b.src;
    const getMenuColumns = () => {
        let totalCols = 6;
        if (type === 'vertical')
            totalCols--;
        if (bannerSrc)
            totalCols--;
        return totalCols;
    };
    const newMenu = convertMegaMenu(menu, getMenuColumns());
    const col = (item) => {
        return item.map((it, index) => (jsxs(MenuLv2, { children: [jsx(CustomLink, Object.assign({}, it.link, { children: jsx(SubTitle, Object.assign({ level: 1, line: 1, color: "primary500", marginBottom: "s8" }, { children: it.name }), void 0) }), void 0), it.children.map((subItem, index) => (createElement(CustomLink, Object.assign({}, subItem.link, { key: index }),
                    jsx(Text, { children: subItem.name }, void 0))))] }, it.name + `-${index}`)));
    };
    return (jsxs(MenuPanelWrapper, Object.assign({ className: className }, { children: [jsx(MenuItemsWrapper, { children: newMenu.map((menu, index) => (jsx(Column, { children: col(menu.column) }, index))) }, void 0), bannerSrc && (jsx(CustomLink, Object.assign({}, menu.banner.link, { children: jsx(EnhancedImage, { src: bannerSrc, width: bannerWidth, height: "100%", googleImageParams: {
                        width: 400,
                    } }, void 0) }), void 0))] }), void 0));
};
const Text = styled.div(({ theme }) => `
  color: ${theme.colors.textPrimary};
  margin-bottom: 4px;
  &:hover {
    color: ${theme.colors.primary500};
  }
`);
const MenuPanelWrapper = styled.div(({ theme }) => `
  background-color: ${theme.colors.white};
  display: flex;
`);
const MenuItemsWrapper = styled.div(({ theme }) => `
  display: flex;
  flex: 1;
  padding: ${theme.spacing.s12};
`);
const MenuLv2 = styled.div `
  margin-bottom: 1.5rem;
`;
const Column = styled.div `
  width: 25%;
  padding: 0 8px;
`;

export { MenuPanel };
